import { forwardRef } from 'react';
import cn from 'classnames';

import { type LotteryRewardName } from '@/common/types/lottery';
import { Picture } from '@/components/ui/Picture/Picture';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import { ticketRewardToTier } from '../config';
import { useCurrentLotteryTier } from '../hooks';
import { isTicketPrize, prizeIcon, prizeValueText } from '../prizes';

import css from './styles.module.scss';

interface RewardValueProps {
  className?: string;
  value: number | string;
  reward: LotteryRewardName;
}

const RewardValue = forwardRef<HTMLSpanElement, RewardValueProps>(
  ({ className, value, reward }, ref) => {
    const currentTicketType = useCurrentLotteryTier();
    const text = prizeValueText(reward, value);
    // T-Gem / dice get their icon; the USDT of old seasons keeps the "$"
    const icon =
      reward === 'tgem' || reward === 'dice' ? prizeIcon(reward) : null;

    return (
      <div className={cn('flex h-[64px] items-end shrink-0', className)}>
        {isTicketPrize(reward) && (
          <TicketIcon
            type={ticketRewardToTier[reward]}
            className="size-[64px] mr-[16px]"
          />
        )}
        {icon && (
          <Picture
            img={icon.png}
            webp={icon.webp}
            alt={reward}
            className="block size-[64px] mr-[12px] shrink-0"
          />
        )}
        <span
          ref={ref}
          data-value={text}
          className={cn(
            css.rewardValue,
            css[`rewardValue--${currentTicketType}`],
          )}
        >
          <span>{text}</span>
        </span>
      </div>
    );
  },
);

export { RewardValue };
